import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Store } from "lucide-react";
import BranchPopup from "../BranchPopup";
import api, { API_BASE } from "../../lib/api";

export default function BranchStrip() {
  const [branches, setBranches] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    api.get("/branches/public").then((r) => setBranches(r.data)).catch(() => {});
  }, []);

  if (!branches.length) return null;

  return (
    <section className="bg-white py-16" data-testid="home-branch-strip">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-saffron">Our Branches</p>
            <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl">
              Find an IndiaFast Branch Near You
            </h2>
          </div>
          <Link to="/branches" data-testid="branch-strip-view-all"
                className="group flex items-center gap-1.5 text-sm font-bold text-saffron transition-colors hover:text-saffron-hover">
            View all branches <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>

        <div className="mt-8 flex snap-x gap-4 overflow-x-auto pb-3" data-testid="branch-strip-list">
          {branches.map((b) => (
            <button key={b.id} onClick={() => setSelected(b)} data-testid={`branch-strip-card-${b.id}`}
                    className="group w-60 shrink-0 snap-start overflow-hidden rounded-2xl border border-slate-200 bg-white text-left shadow-sm transition-all hover:-translate-y-1 hover:border-saffron/40 hover:shadow-xl">
              <div className="relative h-32 overflow-hidden bg-navy">
                {b.photo_path ? (
                  <img src={`${API_BASE}/api/branches/public/photo/${b.id}`} alt={b.shop_name} loading="lazy" className="kenburns-a h-full w-full object-cover" />
                ) : (
                  <div className="grid h-full place-items-center"><Store className="h-8 w-8 text-white/30" /></div>
                )}
                <span className="absolute inset-x-0 bottom-0 h-0.5 bg-gradient-to-r from-saffron via-white to-emerald-600" />
              </div>
              <div className="p-4">
                <p className="truncate font-heading text-sm font-bold text-navy">{b.shop_name}</p>
                <p className="mt-1 flex items-center gap-1 text-[11px] font-semibold text-slate-500">
                  <MapPin className="h-3 w-3 text-saffron" /> {b.city}, {b.state}{b.pincode ? ` · ${b.pincode}` : ""}
                </p>
                <p className="mt-2 text-[11px] font-bold text-saffron opacity-0 transition-opacity group-hover:opacity-100">Tap for details →</p>
              </div>
            </button>
          ))}
        </div>
      </div>
      <BranchPopup b={selected} onClose={() => setSelected(null)} />
    </section>
  );
}
